import Column, { ColumnProps } from "./Column"

export type KanbanTableProps = {
  columns: ColumnProps[]
  dataTestid?: string
}

const KanbanTable = ({ columns, dataTestid }: KanbanTableProps) => {
  return (
    <div className="flex gap-4 overflow-x-auto">
      {columns.map((column, index) => (
        <Column key={`${column.title}-${index}`} dataTestid={dataTestid} {...column} />
      ))}
    </div>
  )
}

export default KanbanTable
